require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./drug-court-costs-and-promising-practices.json") })
        }
      }, "path---drug-court-costs-and-promising-practices");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---drug-court-costs-and-promising-practices!./.cache/json/drug-court-costs-and-promising-practices.json
// module id = 880
// module chunks = 231608221292675